import styled from 'styled-components';

interface IMobileBannerCarouselStyledProps {
    isIndicatorShow?: boolean;
}

export const MobileBannerCarouselStyled = styled.div<IMobileBannerCarouselStyledProps>`
    width: calc(100% + 32px);
    margin: 0 -16px;
    position: relative;

    .slider-wrapper {
        padding: 0 12px;
    }

    .slide {
        padding: 0 4px;
    }

    .carousel-slider {
        overflow: unset;
        display: flex;
        flex-direction: column;
    }

    .control-dots {
        position: unset;
        bottom: -20px;
        margin: 0;
        order: 1;

        .dot {
            margin: 0 2px;
            width: 4px;
            height: 4px;
            border-radius: 2px;
            background: var(--color-label-primary);
            opacity: unset;

            &.selected {
                width: 12px;
            }
        }
    }

    .arrow-left, .arrow-right {
        position: absolute;
        bottom: 0;
        z-index: 2;
        transform: translateY(25%);
        &.disabled {
            color: var(--color-label-secondary);
        }
    }

    .arrow-left {
        left: 0;
    }

    .arrow-right {
        right: 0;
    }
`;
